<div class="tabs-box">
    <ul class="recent-list">
        <li *ngFor="let pointDto of pointDtoList">
            <a>
                <div class="meter-txt">
                    {{ pointDto.altitude }}m
                </div>
                <div class="keyword-txt" (click)="search(pointDto)" [attr.isIgnoreElement]="true">
                    {{ pointDto.address }}
                </div>
                <div class="list-menu">
                    <span class="like-btn type-on" (click)="addBookmark(pointDto)"></span>
                    <span class="remove-btn" (click)="delete(pointDto.seq)"></span>
                </div>
            </a>
        </li>
    </ul>
    <div class="layer-menu-box">
        <a class="all-remove-btn" (click)="deleteAll()">
            {{ "search.searchHistory.deleteAll" | translate }}
        </a>
        <a class="search-layer-close" (click)="close()" [attr.isIgnoreElement]="true">
            {{ "search.searchHistory.unfold" | translate }}
        </a>
    </div>
</div>